import Modal from "react-modal";

const WarningModal = ({
  onClose,
  isOpen,
  children,
}: {
  onClose: () => void;
  isOpen: boolean;
  children: React.ReactNode;
}) => {
  return isOpen ? (
    <Modal
      id="accession-warning-modal"
      testId="accession-warning-modal"
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      contentLabel="Incorrect information"
      className="Modal"
      overlayClassName="Overlay"
    >
      {children}
    </Modal>
  ) : null;
};

export default WarningModal;
